import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import virtualScene from "./components/virtual-scene";
import filterConstruction from "./components/filter-construction";
import convolution from "./components/convolution";

const principle: Slide = {
  description:
    "In virtual reality we need a real-time filter update, if the listener or the sound source moves or rotates. In this flowchart we will analyze how it works.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Virtual scene" }, { name: "Filter construction" }, { name: "Convolution" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], []],
      components: [virtualScene, filterConstruction, convolution],
    },
  },
};

export default principle;
